export const allQuestions = {
  pricingQuestions: [
    {
      question: "What does Sudowrite do, really?",
      answer: "Watch this video.",
      url: "https://youtu.be/BU0-dgukXQ8",
    },
    {
      question: "What languages does Sudowrite work in?",
      answer:
        "You can write text in almost any language, click Write, and Sudowrite will match your language when it offers suggestions. When using other features, Sudowrite may fall back on English when it isn't sure. Try it out in our free trial to see how it works for you!",
    },
    {
      question: "Is this magic?",
      answer: "Basically.",
    },
    {
      question: "Before I sign up - How do I cancel?",
      answer: "It’s easy. Go to your subscription page and hit cancel. No phone calls, no nonsense.",
    },
    {
      question: "If I cancel, do I lose access to what I’ve written in Sudowrite?",
      answer: "You can always access and work on your projects in Sudowrite, but won’t be able to use AI features without a paid plan. We will never hold your writing hostage.",
    },
    {
      question: "Do you claim any rights or ownership over what I write in Sudowrite?",
      answer: "Nope.",
    },
    {
      question: "How do I know how many AI-generated words I’ll need?",
      answer:
        "If you’re writing at least a few days a week, you’ll probably want the professional plan. But you can always upgrade, downgrade, or just plain cancel. So try whatever you like to start!",
    },
    {
      question: "What public language models does Sudowrite use?",
      answer:
        "We use over two dozen AI models, including Claude 2 by Anthropic, multiple open models, and several variants of GPT-3.5, and GPT-4, transformer models created by OpenAI. OpenAI trained their models on: (1) a version of the CommonCrawl dataset, filtered based on similarity to high-quality reference corpora, (2) an expanded version of the Webtext dataset, (3) two internet-based book corpora, and (4) English-language Wikipedia. We pair these models with a variety of proprietary narrative model-based and algorithmic pre- and post-processing to enable AI writing features not available anywhere else.",
    },
    {
      question: "What’s your stance on plagiarism?",
      answer: "Don’t do it. It’s not cool. Sudowrite generates 100% original text as long as you do the same.",
    },
    {
      question: "What if I don’t like it?",
      answer: "We’d be surprised! But nothing pleases everyone. If you’re not 100% satisfied, email us anytime in the first week. We’ll refund you!",
    },
  ],
  mainQuestions: [
    {
      question: "What does Sudowrite do, really?",
      answer: "Watch this video.",
      url: "https://youtu.be/LwUIAvOIGUE",
    },
    {
      question: "What languages does Sudowrite work in?",
      answer:
        "You can write text in almost any language, click Write, and Sudowrite will match your language when it offers suggestions. When using other features, Sudowrite may fall back on English when it isn't sure. Try it out in our free trial to see how it works for you!",
    },
    {
      question: "Is this magic?",
      answer: "Yes. But so is life, isn't it?",
    },
    {
      question: "Do you claim any rights or ownership over what I write in Sudowrite?",
      answer: "We claim no rights over anything you put into Sudowrite, nor anything Sudowrite generates for you.",
    },
    {
      question: "Can Sudowrite plagiarize?",
      answer:
        "The short answer is, Sudowrite won't plagiarize unless you explicitly force it to plagiarize, which is against our terms of service.<br/>The AI works by guessing one word at a time, based on general concepts it has learned from billions of samples of text. So it's extremely unlikely to produce the same words verbatim, or even ever again. It does not copy and paste chunks of text, it guesses each word (technically, parts of words), one at a time.<br/>The only way to get Sudowrite to plagiarize is to put in text it's seen before verbatim, like the lyrics of an  popular song, or the first paragraph of an extremely popular book like Harry Potter. As long as your own writing is original, you'll get more original writing out of Sudowrite. We encourage you to try plagiarism checkers to verify your results.",
    },
    {
      question: "Is this cheating?",
      answer:
        "Sudowrite is a tool for creativity. It's not intended to write for you, but can help you vastly improve and speed up your writing. Just as a great writing partner can help you bust through when you're stuck or be a sounding board to bounce ideas off of, Sudowrite makes writing more fun, faster, and less solitary.",
    },
    {
      question: "What public language models does Sudowrite use?",
      answer:
        "We use over two dozen AI models, including Claude 2 by Anthropic, multiple open models, and several variants of GPT-3.5, and GPT-4, transformer models created by OpenAI. OpenAI trained their models on: (1) a version of the CommonCrawl dataset, filtered based on similarity to high-quality reference corpora, (2) an expanded version of the Webtext dataset, (3) two internet-based book corpora, and (4) English-language Wikipedia. We pair these models with a variety of proprietary narrative model-based and algorithmic pre- and post-processing to enable AI writing features not available anywhere else.",
    },
    {
      question: "Does Sudowrite learn and improve from my writing?",
      answer: "We are constantly listening to writers' feedback to improve Sudowrite. However, we do not use your writing to train Sudowrite or OpenAI's AI models.",
    },
    {
      question: "Before I sign up, how do I cancel?",
      answer: "It’s easy. Go to your subscription page and hit cancel. No phone calls, no nonsense.",
    },

    {
      question: "If I cancel, do I lose access to what I’ve written in Sudowrite?",
      answer: "You can always access and work on your projects in Sudowrite, but won’t be able to use AI features without a paid plan. We will never hold your writing hostage.",
    },

  ],
};
